import {
  AutoCompleteTailwindThemes,
  AvatarTailwindThemes,
  BadgeTailwindThemes,
  ButtonTailwindThemes,
  CalendarTailwindThemes,
  CardTailwindThemes,
  CheckboxTailwindThemes,
  ChipsTailwindThemes,
  ChipTailwindThemes,
  ContextMenuTailwindThemes,
  DialogTailwindThemes,
  DropdownTailwindThemes,
  IconFieldTailwindThemes,
  InputIconTailwindThemes,
  InputMaskTailwindThemes,
  InputNumberTailwindThemes,
  InputSwitchTailwindThemes,
  InputTextareaTailwindThemes,
  InputTextTailwindThemes,
  MenuTailwindThemes,
  MultiSelectTailwindThemes,
  ProgressSpinnerTailwindThemes,
  RadioButtonTailwindThemes,
  SidebarTailwindThemes,
  SkeletonTailwindThemes,
  TabViewTailwindThemes,
  ToastTailwindThemes,
  TooltipTailwindThemes,
  TreeTailwindThemes,
} from '@repo/atomic-components';

export const PrimeReactTailwindThemes = {
  ...AutoCompleteTailwindThemes,
  ...AvatarTailwindThemes,
  ...BadgeTailwindThemes,
  ...ButtonTailwindThemes,
  ...CalendarTailwindThemes,
  ...CardTailwindThemes,
  ...CheckboxTailwindThemes,
  ...ChipsTailwindThemes,
  ...ChipTailwindThemes,
  ...ContextMenuTailwindThemes,
  ...DialogTailwindThemes,
  ...DropdownTailwindThemes,
  ...IconFieldTailwindThemes,
  ...InputIconTailwindThemes,
  ...InputMaskTailwindThemes,
  ...InputNumberTailwindThemes,
  ...InputSwitchTailwindThemes,
  ...InputTextareaTailwindThemes,
  ...InputTextTailwindThemes,
  ...MenuTailwindThemes,
  ...MultiSelectTailwindThemes,
  ...ProgressSpinnerTailwindThemes,
  ...RadioButtonTailwindThemes,
  ...SidebarTailwindThemes,
  ...SkeletonTailwindThemes,
  ...TabViewTailwindThemes,
  ...ToastTailwindThemes,
  ...TooltipTailwindThemes,
  ...TreeTailwindThemes,
};
